/**
 * ==========================================
 *  STRIPE SERVICE - PROJECTBOOST
 *  Project ID: projectboost-4ad76
 * ==========================================
 * 
 * ✅ VERSION PAYMENT LINKS STRIPE
 * Configuration simple et fiable
 */

/**
 * 🔧 CONFIGURATION DES PAYMENT LINKS
 * 
 * Vos liens Stripe actuels (MODE TEST) :
 */
const PAYMENT_LINKS = {
  silver: 'https://buy.stripe.com/00wfZi0wl47I5Fy9QCcAo02',
  gold: 'https://buy.stripe.com/6oUfZibaZ47Ic3W6EqcAo01',
  single: 'https://buy.stripe.com/eVqdRa3Ix47I5Fy4wicAo00',
};

// 🚨 IMPORTANT : Pour passer en PRODUCTION (LIVE)
// Remplacez par vos liens LIVE depuis Stripe Dashboard
// const PAYMENT_LINKS = {
//   silver: 'https://buy.stripe.com/live_XXXXX',
//   gold: 'https://buy.stripe.com/live_XXXXX',
//   single: 'https://buy.stripe.com/live_XXXXX',
// };

/**
 * ==============================
 *  ABONNEMENT SILVER
 * ==============================
 */
export const subscribeSilver = async (userId, userEmail) => {
  try {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('🔵 DÉBUT - Abonnement Silver');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    
    // ✅ VÉRIFICATION 1 : userId présent
    console.log('🔍 Vérification userId...');
    console.log('   → userId:', userId);
    console.log('   → Type:', typeof userId);
    console.log('   → Valide:', userId ? '✅ OUI' : '❌ NON');
    
    if (!userId) {
      console.error('❌ ERREUR CRITIQUE : userId est vide ou undefined');
      alert('Erreur : Impossible de récupérer votre identifiant utilisateur. Veuillez vous reconnecter.');
      return { success: false, error: 'userId manquant' };
    }
    
    // ✅ VÉRIFICATION 2 : userEmail présent
    console.log('🔍 Vérification userEmail...');
    console.log('   → userEmail:', userEmail);
    console.log('   → Valide:', userEmail ? '✅ OUI' : '❌ NON');
    
    if (!userEmail) {
      console.warn('⚠️ WARNING : userEmail est vide (non critique)');
    }

    // ✅ SAUVEGARDER LE PLAN DANS LOCALSTORAGE
    console.log('💾 Sauvegarde du plan dans localStorage...');
    localStorage.setItem('pendingPlan', 'silver');
    console.log('   → Plan sauvegardé: silver');

    // ✅ CONSTRUCTION DE L'URL
    console.log('🔨 Construction de l\'URL Stripe...');
    console.log('   → Payment Link:', PAYMENT_LINKS.silver);
    
    const url = new URL(PAYMENT_LINKS.silver);
    url.searchParams.set('client_reference_id', userId);
    
    if (userEmail) {
      url.searchParams.set('prefilled_email', userEmail);
    }

    const finalUrl = url.toString();
    console.log('✅ URL construite avec succès');
    console.log('   → URL complète:', finalUrl);
    console.log('   → Paramètres:');
    console.log('      • client_reference_id:', userId);
    console.log('      • prefilled_email:', userEmail || 'non fourni');

    // ✅ REDIRECTION
    console.log('🚀 REDIRECTION vers Stripe...');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
    
    window.location.href = finalUrl;

    return { success: true };
    
  } catch (error) {
    console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.error('❌ ERREUR DANS subscribeSilver');
    console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.error('Message:', error.message);
    console.error('Stack:', error.stack);
    console.error('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
    
    alert(`Erreur lors de la création de la session de paiement: ${error.message}`);
    return { success: false, error: error.message };
  }
};

/**
 * ==============================
 *  ABONNEMENT GOLD
 * ==============================
 */
export const subscribeGold = async (userId, userEmail) => {
  try {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('🟡 DÉBUT - Abonnement Gold');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    
    console.log('🔍 Vérification userId...');
    console.log('   → userId:', userId);
    console.log('   → Valide:', userId ? '✅ OUI' : '❌ NON');
    
    if (!userId) {
      console.error('❌ ERREUR CRITIQUE : userId est vide');
      alert('Erreur : Impossible de récupérer votre identifiant utilisateur. Veuillez vous reconnecter.');
      return { success: false, error: 'userId manquant' };
    }
    
    console.log('🔍 Vérification userEmail...');
    console.log('   → userEmail:', userEmail);
    
    // ✅ SAUVEGARDER LE PLAN
    console.log('💾 Sauvegarde du plan dans localStorage...');
    localStorage.setItem('pendingPlan', 'gold');
    console.log('   → Plan sauvegardé: gold');
    
    console.log('🔨 Construction de l\'URL Stripe...');
    const url = new URL(PAYMENT_LINKS.gold);
    url.searchParams.set('client_reference_id', userId);
    
    if (userEmail) {
      url.searchParams.set('prefilled_email', userEmail);
    }

    const finalUrl = url.toString();
    console.log('✅ URL construite:', finalUrl);
    console.log('🚀 REDIRECTION vers Stripe...');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
    
    window.location.href = finalUrl;

    return { success: true };
    
  } catch (error) {
    console.error('❌ ERREUR DANS subscribeGold:', error.message);
    console.error('Stack:', error.stack);
    alert(`Erreur lors de la création de la session de paiement: ${error.message}`);
    return { success: false, error: error.message };
  }
};

/**
 * ===================================
 *  DIAGNOSTIC UNIQUE
 * ===================================
 */
export const buySingleDiagnostic = async (userId, userEmail) => {
  try {
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    console.log('📊 DÉBUT - Diagnostic Unique');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
    
    console.log('🔍 Vérification userId...');
    console.log('   → userId:', userId);
    console.log('   → Valide:', userId ? '✅ OUI' : '❌ NON');
    
    if (!userId) {
      console.error('❌ ERREUR CRITIQUE : userId est vide');
      alert('Erreur : Impossible de récupérer votre identifiant utilisateur. Veuillez vous reconnecter.');
      return { success: false, error: 'userId manquant' };
    }
    
    console.log('🔍 Vérification userEmail...');
    console.log('   → userEmail:', userEmail);
    
    // ✅ SAUVEGARDER LE PLAN
    console.log('💾 Sauvegarde du plan dans localStorage...');
    localStorage.setItem('pendingPlan', 'single');
    console.log('   → Plan sauvegardé: single');
    
    console.log('🔨 Construction de l\'URL Stripe...');
    const url = new URL(PAYMENT_LINKS.single);
    url.searchParams.set('client_reference_id', userId);
    
    if (userEmail) {
      url.searchParams.set('prefilled_email', userEmail);
    }

    const finalUrl = url.toString();
    console.log('✅ URL construite:', finalUrl);
    console.log('🚀 REDIRECTION vers Stripe...');
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
    
    window.location.href = finalUrl;

    return { success: true };
    
  } catch (error) {
    console.error('❌ ERREUR DANS buySingleDiagnostic:', error.message);
    console.error('Stack:', error.stack);
    alert(`Erreur lors de la création de la session de paiement: ${error.message}`);
    return { success: false, error: error.message };
  }
};

/**
 * ===================================
 *  HELPERS (COMPATIBILITÉ)
 * ===================================
 */
export const createCheckoutSession = async (priceId, userId, userEmail) => {
  console.warn('⚠️ createCheckoutSession est déprécié. Utilisez subscribeSilver/subscribeGold directement.');
  
  // Rediriger vers la bonne fonction selon le priceId
  if (priceId === process.env.REACT_APP_STRIPE_PRICE_SILVER) {
    return subscribeSilver(userId, userEmail);
  } else if (priceId === process.env.REACT_APP_STRIPE_PRICE_GOLD) {
    return subscribeGold(userId, userEmail);
  } else {
    console.error('❌ Price ID non reconnu:', priceId);
    return { success: false, error: 'Price ID non reconnu' };
  }
};

export const createSinglePaymentSession = async (userId, userEmail) => {
  console.warn('⚠️ createSinglePaymentSession est déprécié. Utilisez buySingleDiagnostic directement.');
  return buySingleDiagnostic(userId, userEmail);
};

/**
 * ==========================================
 * 🔍 FONCTION DE DEBUG (OPTIONNELLE)
 * ==========================================
 * 
 * Utilisez cette fonction pour vérifier que tout est OK
 * avant de faire un paiement.
 * 
 * Utilisation :
 * import { debugStripeConfig } from './stripeService';
 * debugStripeConfig(userId, userEmail);
 */
export const debugStripeConfig = (userId, userEmail) => {
  console.log('\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  console.log('🔍 DEBUG - CONFIGURATION STRIPE');
  console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━');
  
  console.log('\n📋 Payment Links configurés:');
  console.log('   • Silver:', PAYMENT_LINKS.silver);
  console.log('   • Gold:', PAYMENT_LINKS.gold);
  console.log('   • Single:', PAYMENT_LINKS.single);
  
  console.log('\n👤 Données utilisateur:');
  console.log('   • userId:', userId || '❌ MANQUANT');
  console.log('   • userEmail:', userEmail || '❌ MANQUANT');
  
  console.log('\n✅ Status:');
  console.log('   • Payment Links:', PAYMENT_LINKS.silver ? '✅ OK' : '❌ MANQUANT');
  console.log('   • userId:', userId ? '✅ OK' : '❌ MANQUANT');
  console.log('   • userEmail:', userEmail ? '✅ OK' : '⚠️ OPTIONNEL');
  
  if (userId) {
    console.log('\n🔨 URL de test (Silver):');
    const testUrl = new URL(PAYMENT_LINKS.silver);
    testUrl.searchParams.set('client_reference_id', userId);
    if (userEmail) {
      testUrl.searchParams.set('prefilled_email', userEmail);
    }
    console.log(testUrl.toString());
  }
  
  console.log('\n━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n');
};

/**
 * ==========================================
 * 📝 INSTRUCTIONS D'UTILISATION
 * ==========================================
 * 
 * ✅ DÉJÀ CONFIGURÉ POUR VOUS :
 * 
 * Payment Links (MODE TEST) :
 * - Silver: https://buy.stripe.com/00wfZi0wl47I5Fy9QCcAo02
 * - Gold: https://buy.stripe.com/6oUfZibaZ47Ic3W6EqcAo01
 * - Single: https://buy.stripe.com/eVqdRa3Ix47I5Fy4wicAo00
 * 
 * ⚠️ POUR PASSER EN PRODUCTION (LIVE) :
 * 1. Créer les Payment Links en mode LIVE dans Stripe
 * 2. Remplacer les liens dans PAYMENT_LINKS ci-dessus
 * 3. Vérifier le webhook est en mode LIVE
 * 4. Déployer
 * 
 * 🧪 POUR TESTER :
 * 1. Ouvrir la console (F12)
 * 2. Cliquer sur "S'abonner"
 * 3. Vérifier les logs détaillés
 * 4. Carte test : 4242 4242 4242 4242
 * 
 * ==========================================
 */